// extracted by mini-css-extract-plugin
module.exports = {"container":"ModalHeader_container__117Jh","titleContainer":"ModalHeader_titleContainer__3TPBj","title":"ModalHeader_title__3VXVm","desc":"ModalHeader_desc__3pTaP"};